// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-player[data-v-1bd5c5d0]{background-color:#f7faff}", ""]);
// Exports
module.exports = exports;
